module.exports = __webpack_public_path__ + "resources/img/career-planImg.43f6493d.png";